export default function selectMeta(state, fetchKey) {
  return state.meta[fetchKey];
}